import { defer } from 'react-router-dom'

import { isAppStateReady } from '$appStore'

/**
 * Loader for the Manage Venues route, just waits for the app state to be
 * available before resolving.
 *
 * We internally load subscription data inside the component itself as we know
 * the call to get subscription data is very slow and want to show the remainder
 * of the page while that response is waited on.
 */
export default async function loader() {
  await isAppStateReady()

  return defer({ data: Promise.resolve(true) })
}
